import {ReactComponent as AmexSvg} from 'assets/paymentIcons/amex.svg';
import {ReactComponent as CheckPaymentSvg} from 'assets/paymentIcons/checkpayment.svg';
import {ReactComponent as CreditCardSvg} from 'assets/paymentIcons/creditcard.svg';
import {ReactComponent as DinersClubSvg} from 'assets/paymentIcons/dinersclub.svg';
import {ReactComponent as DiscoverSvg} from 'assets/paymentIcons/discover.svg';
import {ReactComponent as GiftCardSvg} from 'assets/paymentIcons/giftcard.svg';
import {ReactComponent as GravitySvg} from 'assets/paymentIcons/GravityIcon.svg';
import {ReactComponent as JCBSvg} from 'assets/paymentIcons/jcbcard.svg';
import {ReactComponent as MastercardHorizSvg} from 'assets/paymentIcons/mc_hrz_pos.svg';
import {ReactComponent as MastercardVertSvg} from 'assets/paymentIcons/mc_vrt_pos.svg';
import {ReactComponent as UnionPaySvg} from 'assets/paymentIcons/unionpay.svg';
import {ReactComponent as VisaSvg} from 'assets/paymentIcons/visa.svg';
import {ReactComponent as VisaWhiteSvg} from 'assets/paymentIcons/VisaWhite.svg';
import {ReactComponent as VisaBlueSvg} from 'assets/paymentIcons/VisaBlue.svg';

const AmexIcon = props => {
    return <AmexSvg alt='Amex' {...props} />;
};

const CheckPaymentIcon = props => {
    return <CheckPaymentSvg alt='Check-payment' {...props} />;
};

const CreditCardIcon = props => {
    return <CreditCardSvg alt='credit-card' {...props} />;
};

const DinersClubIcon = props => {
    return <DinersClubSvg alt='diners-club' {...props} />;
};

const DiscoverIcon = props => {
    return <DiscoverSvg alt='Discover-card' {...props} />;
};

const GiftCardIcon = props => {
    return <GiftCardSvg alt='Gift-card' {...props} />;
};

const GravityIcon = props => {
    return <GravitySvg alt='Gravity' {...props} />;
};

const JCBIcon = props => {
    return <JCBSvg alt='JCB-card' {...props} />;
};

const MastercardVertIcon = props => {
    return <MastercardVertSvg alt='Mastercard' {...props} />;
};

const MastercardHorizIcon = props => {
    return <MastercardHorizSvg alt='Mastercard' {...props} />;
};

const UnionPayIcon = props => {
    return <UnionPaySvg alt='UnionPay' {...props} />;
};

const VisaIcon = props => {
    return <VisaSvg alt='Visa' {...props} />;
};

const VisaWhiteIcon = props => {
    return <VisaWhiteSvg alt='Visa-white' {...props} />;
};

const VisaBlueIcon = props => {
    return <VisaBlueSvg alt='Visa-blue' {...props} />;
};

export {
    AmexIcon,
    CheckPaymentIcon,
    CreditCardIcon,
    DinersClubIcon,
    DiscoverIcon,
    GiftCardIcon,
    GravityIcon,
    JCBIcon,
    MastercardHorizIcon,
    MastercardVertIcon,
    UnionPayIcon,
    VisaIcon,
    VisaWhiteIcon,
    VisaBlueIcon,
};
